import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  deleteActiveDrivers,
  deleteDriver,
  getAllActiveDrivers,
  updateDriverStatus,
} from "../../services/DriverService.ts";
import CoreTable from "../../coreComponents/Table/Table.tsx";

interface Vehicle {
  id: number;
  driverId: number;
  vehicle_no: string;
  vehicle_type: string;
}

interface DriverData {
  id: number;
  name: string;
  location: string;
  dob: string;
  email: string | null;
  isVerified: boolean;
  phone: string;
  preferred_language: string;
  vehicles: Vehicle[];
  status: string;
  isActive: boolean;
}

const columns = [
  { id: "id", label: "ID" },
  { id: "name", label: "Name" },
  { id: "location", label: "Location" },
  { id: "status", label: "Status" },
  { id: "phone", label: "Phone" },
  { id: "isVerified", label: "Verified" },
  { id: "isActive", label: "Active" },
];

const ActiveDriver: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(true);
  const [driverData, setDriverData] = useState<DriverData[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchDriverData = async () => {
      try {
        const response = await getAllActiveDrivers();
        if (response.data) {
          console.log(response.data);
          const drivers =  response.data.map((d) => ({
            ...d,
            location: d.current_location.address
          }))
          setDriverData(drivers);
        }
      } catch (err: any) {
        if (err.response && err.response.status === 401) {
          console.error("Unauthorized access. Redirecting to login...");
          navigate("/login");
        } else {
          setError("Failed to fetch drivers");
          console.log(err);
        }
      } 
      finally {
        setLoading(false);
      }
    };

    fetchDriverData();
  }, []);

  const handleUpdate = async (id: number) => {
    const response = await updateDriverStatus(id);
    if (response.data) {
      console.log("Driver status updated successfully:", response);
      setDriverData((prev) =>
        prev.map((driver) =>
          driver.id === id ? { ...driver, status: "FREE" } : driver
        )
      );
    }
  };

  const handleDelete = async (id: number) => {
    const response = await deleteActiveDrivers(id);
    console.log(response.data);

    if (response.data) {
      const updatedDriverData = driverData.filter((driver) => driver.id !== id);
      setDriverData(updatedDriverData);
    }
  };

  if (loading && driverData.length === 0) return <div>Loading Active drivers...</div>;

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
      </div>
      <CoreTable
        columns={columns}
        data={driverData.map((driver) => ({
          ...driver,
          isActive: driver.isActive ? "true" : "false",
          isVerified: driver.isVerified ? "true" : "false",
        }))}
        // onUpdate={handleUpdate}
        // onDelete={handleDelete}
      />
    </div>
  );
};

export default ActiveDriver;
